module.exports = __webpack_public_path__ + "img/H000170_crab.5bf080a4.png";